import { render, staticRenderFns } from "./SingleClasses.vue?vue&type=template&id=53a2ef04"
import script from "./SingleClasses.vue?vue&type=script&lang=js"
export * from "./SingleClasses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports